import React from 'react';
import PropTypes from 'prop-types';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
import Icon from '../../elements/Icon';

const PropertyCode = ({
  item,
  showPropertyCode,
  propertyCodeContainerProps,
  propertyCodeLabelProps,
  labelContainerProps,
  labelProps,
  showParenthesis,
  showMenuIcon,
  menuIcon,
  showSecondaryText,
  secondaryLabelProps
}) => {
  let { value } = item;
  if (showParenthesis) {
    value = `(${item.value})`;
  }

  return (
    <>
      {showMenuIcon && (
        <Box>
          <Icon icon={item?.icon} size={20} {...menuIcon} />
        </Box>
      )}
      {showPropertyCode && (
        <Box {...propertyCodeContainerProps}>
          <Text {...propertyCodeLabelProps}>{value}</Text>
        </Box>
      )}
      <Box {...labelContainerProps}>
        <Text {...labelProps}>{item.label}</Text>
        {showSecondaryText && <Text {...secondaryLabelProps}>{item?.secondaryLabel}</Text>}
      </Box>
    </>
  );
};

PropertyCode.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  showPropertyCode: PropTypes.bool,
  propertyCodeLabelProps: PropTypes.objectOf(PropTypes.any),
  propertyCodeContainerProps: PropTypes.objectOf(PropTypes.any),
  labelProps: PropTypes.objectOf(PropTypes.any),
  labelContainerProps: PropTypes.objectOf(PropTypes.any),
  showParenthesis: PropTypes.bool
};

PropertyCode.defaultProps = {
  showPropertyCode: true,
  propertyCodeLabelProps: {
    paddingTop: '2px'
  },
  propertyCodeContainerProps: {
    border: true,
    paddingWidth: '1',
    marginRight: '2',
    floatLeft: true,
    textAlign: 'center',
    fontWeight: 'bold',
    style: { minWidth: '45px' }
  },
  labelProps: {},
  labelContainerProps: {},
  showParenthesis: false,
  showMenuIcon: false,
  showSecondaryText: false,
  menuIcon: {},
  secondaryLabelContainerProps: {},
  secondaryLabelProps: {}
};

export default PropertyCode;
